// extracted by mini-css-extract-plugin
export var messageSideLeft = "_mr-1";
export var messageSideRight = "_mr-2";
export var orderLookupBubbleContainer = "_mr-0";
export var submitButton = "_mr-3";